export default __webpack_public_path__ + "static/media/userProfile.99b3d451.svg";